"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Tile_1 = require("../tile/Tile");
const Meld_1 = require("./Meld");
/**
 * This is a light-weighted function that takes an array of Unicode strings (e.g. ["🀀", "🀀", "🀀"]) to form a Meld.
 * @param inputTilesStrings an input array of strings that must be Unicode strings of Mahjong.
 * @returns the Meld formed.
 */
function meldFormer(inputTilesStrings) {
    const tiles = [];
    for (const tile of inputTilesStrings) {
        tiles.push(new Tile_1.default(tile));
    }
    const meldFormed = new Meld_1.default(tiles);
    return meldFormed;
}
exports.default = meldFormer;
